import { render, staticRenderFns } from "./DatoExtendidoForm.vue?vue&type=template&id=97707f36&scoped=true&"
import script from "./DatoExtendidoForm.vue?vue&type=script&lang=ts&"
export * from "./DatoExtendidoForm.vue?vue&type=script&lang=ts&"
import style0 from "./DatoExtendidoForm.vue?vue&type=style&index=0&id=97707f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97707f36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('97707f36', component.options)
    } else {
      api.reload('97707f36', component.options)
    }
    module.hot.accept("./DatoExtendidoForm.vue?vue&type=template&id=97707f36&scoped=true&", function () {
      api.rerender('97707f36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Dispositivos/DatoExtendidoForm.vue"
export default component.exports